export default "__VITE_ASSET__4c3c8d1c__"